import React, { useState } from 'react';
import { LandingPage } from './components/LandingPage.tsx';
import { PasswordGate } from './components/PasswordGate.tsx';
import { Toaster } from 'sonner';
import "../../../styles/tailwind.css";
import TailwindWrapper from './components/TailwindWrapper.tsx';
export default function LoyalFreaks() {
  const [isUnlocked, setIsUnlocked] = useState(false);

  if (!isUnlocked) {
    return (
      <div style={{ fontFamily: 'sans-serif' }}>
        <PasswordGate onUnlock={() => setIsUnlocked(true)} />
      </div>
    );
  }

  return (
    <div style={{ fontFamily: 'sans-serif' }}>
        <LandingPage />
      <Toaster />
    </div>
  );
}
